import React from 'react';
import { DropletIcon } from 'lucide-react';
export const WaterSanitationWidget = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-2179">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-2180">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-2181">
          <DropletIcon className="h-5 w-5 text-cyan-500 mr-2" data-id="element-2182" />
          Water & Sanitation
        </h2>
      </div>
      <div className="p-6" data-id="element-2183">
        <div className="flex flex-col space-y-4" data-id="element-2184">
          <div className="flex justify-between items-center" data-id="element-2185">
            <span className="text-sm text-gray-600" data-id="element-2186">
              Reported Leaks/Blockages
            </span>
            <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2187">
              5
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-2188">
            <span className="text-sm text-gray-600" data-id="element-2189">
              New Connection Requests
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2190">
              8
            </span>
          </div>
          <div className="flex justify-between items-center" data-id="element-2191">
            <span className="text-sm text-gray-600" data-id="element-2192">Water Quality Alerts</span>
            <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-2193">
              0
            </span>
          </div>
          <div className="mt-4 bg-gray-100 rounded-lg p-3" data-id="element-2194">
            <p className="text-xs text-gray-700 font-medium" data-id="element-2195">
              Scheduled Maintenance
            </p>
            <div className="mt-2 text-xs text-gray-600" data-id="element-2196">
              <p data-id="element-2197">• Main Line Flushing - North District</p>
              <p data-id="element-2198">• Pump Station 3 - Inspection</p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex border-t border-gray-200 divide-x divide-gray-200" data-id="element-2199">
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2200">
          View Service Alerts
        </a>
        <a href="#" className="flex-1 px-4 py-3 text-sm font-medium text-blue-600 hover:text-blue-800 text-center" data-id="element-2201">
          Manage Connections
        </a>
      </div>
    </div>;
};